import axios from "axios";
// PERF-OPT-2026-08-28: Original unused crypto imports retained for rollback; this service uses the native Web Crypto API below.
// import CryptoJS from 'crypto-js';
// import forge from 'node-forge';

// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_c0ebcc55",
  GOLDRATE:"da_46725_39c8e5e1"
};

// lsq base URL
const LSQ_BASE_URL =
  "https://pstech.leadsquaredapps.com/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    // console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};

export function getLsqLeadBody(formData) {
  let Config = {
    utm_medium: "SourceMedium",
    utm_source: "mx_Source_UTM",
    ModeOfLead: "Source",
    name: "FirstName",
    EmailAddress: "EmailAddress",
    Branch: "mx_nearestBranchGL",
    mobile: "Mobile",
    Company: "mx_Company_name",
    Occupation: "mx_Employment_Type",
    gclid: "mx_Gclid",
    Referral: "mx_Referral",
    Eligible: "mx_Eligible",
    Relationship: "mx_Relationship",
    utm_term: "mx_Utm_Terms",
    utm_lms: "mx_utm_lms",
    User_Agent: "mx_Lead_Device",
    IsAuthorized: "mx_Iauthorization",
    DND: "mx_DND_NDNC",
    CompleteUrl: "mx_UTM_URL_Details",
    utm_campaign: "SourceCampaign",
    utm_content: "SourceContent",
    Product: "mx_Product",
    Pincode: "mx_Pincode",
    token: "mx_Token",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    isChecked:"mx_Iauthorization",
    CampaignId: "mx_Campaign_ID"
  };
  let LeadBody = [];
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  return LeadBody;
}

export async function hashMobileNum(mobileNum){
  
    if (mobileNum){
      let formattedNum = await formatAndValidateE164(mobileNum);
     let hashedMobile= await hashValue(formattedNum)
    await setValuesInLocalStorage(hashedMobile )
    }else{
      console.log("Mobile number is empty")
    }
  }

 async function hashValue(value) {
    // Ensure the input is a string
    if (typeof value !== 'string') {
      value = String(value || ''); // Convert to string or default to an empty string
    }

    // Convert input string to lowercase and trim any extra spaces
    const input = value.trim().toLowerCase();

    // Compute the hash using Web Crypto API
    const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));

    // Convert the hash buffer to a hexadecimal string
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }

  async function setValuesInLocalStorage(mobile) {
    var data = {
      mobile
    };
    // Convert the data to a JSON string
    var jsonData = JSON.stringify(data);
    // Store the JSON string in local storage
    localStorage.setItem("userData", jsonData);
  }

  async function formatAndValidateE164(phoneNumber) {
    // Fixed country code with '+'
    const countryCode = '91';

    // Remove all non-numeric characters except '+'
    let cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');

    // Remove any leading '+' for now
    if (cleanedNumber.startsWith('+')) {
        cleanedNumber = cleanedNumber.substring(1);
    }

    // Ensure the number starts with country code '91'
    if (!cleanedNumber.startsWith(countryCode)) {
        cleanedNumber = countryCode + cleanedNumber;
    }

    // Add the `+` prefix back
    cleanedNumber = `+${cleanedNumber}`;
    console.log("cleanedNumber", cleanedNumber)
    // E.164 validation: 11 to 15 digits, including the '+' sign
    const e164Regex = /^\+?[1-9]\d{10,14}$/;
    if (e164Regex.test(cleanedNumber)) {
        return cleanedNumber; // Valid E.164 formatted number
    } else {
        return null; // Invalid format
    }
}


// Generate Random String for Session Key and IV
const generateRandomString = (length) => {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => ('0' + (byte % 256)).slice(-2)).join('').slice(0, length);
};

// RSA Encryption Function with Dynamic Public Key Fetch
const rsaEncryptSessionKey = async (sessionKey) => {
  try {
  const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;
  if (!publicKeyPem) {
    throw new Error("Public key not found in environment variables");
  }

      // Convert PEM to CryptoKey
      const publicKey = await crypto.subtle.importKey(
          "spki", 
          pemToArrayBuffer(publicKeyPem), 
          {
              name: "RSA-OAEP",
              hash: "SHA-256"
          },
          true,
          ["encrypt"]
      );

      // Encrypt the session key
      const encryptedKey = await crypto.subtle.encrypt(
          { name: "RSA-OAEP" },
          publicKey,
          new TextEncoder().encode(sessionKey)
      );

      return bufferToBase64(encryptedKey);
  } catch (error) {
      console.error('Failed to load or encrypt with public key:', error);
      throw error;
  }
};

// AES Encryption Function using Web Crypto API
const aesEncrypt = async (data, sessionKey, iv) => {
  // Convert session key and IV to ArrayBuffer
  const key = await crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(sessionKey),
      { name: "AES-CBC" },
      false,
      ["encrypt"]
  );

  const encryptedData = await crypto.subtle.encrypt(
      {
          name: "AES-CBC",
          iv: new TextEncoder().encode(iv)
      },
      key,
      new TextEncoder().encode(data)
  );

  return new Uint8Array(encryptedData);
};

// Utility: Convert PEM to ArrayBuffer
function pemToArrayBuffer(pem) {
  const base64 = pem.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '');
  const binary = atob(base64);
  const buffer = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
      buffer[i] = binary.charCodeAt(i);
  }
  return buffer.buffer;
}

// Utility: Convert ArrayBuffer to Base64
function bufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  return btoa(String.fromCharCode.apply(null, bytes));
}

// Main Encryption Function that can be called externally
export const encryptBody = async (payload)=> {
  const sessionKey = generateRandomString(16);  // 16-byte session key
  const iv = generateRandomString(16);  // 16-byte IV for AES

  // Encrypt session key with RSA using the fetched public key
  const encryptedSessionKey = await rsaEncryptSessionKey(sessionKey);

  // Encrypt the payload with AES
  const encryptedDataArrayBuffer = await aesEncrypt(JSON.stringify(payload), sessionKey, iv);

  // Combine IV with encrypted data
  const encryptedData = new Uint8Array(16 + encryptedDataArrayBuffer.byteLength);
  encryptedData.set(new TextEncoder().encode(iv), 0); // First 16 bytes are IV
  encryptedData.set(new Uint8Array(encryptedDataArrayBuffer), 16); // Rest is encrypted data

  // Return the encrypted session key and data
  return {
      requestId: '',
      service: '',
      encryptedKey: encryptedSessionKey,
      encryptedData: bufferToBase64(encryptedData),
      oaepHashingAlgorithm: 'NONE',
      iv: '',
      clientInfo: '',
      optionalParam: ''
  };
}
